import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { createSetlist, mySetlists, type Setlist , deleteSetlist } from "../lib/setlists";

export function Setlists() {
  const [lists, setLists] = useState<Setlist[]>([]);
  const [name, setName] = useState("");

  useEffect(() => { mySetlists().then(setLists); }, []);

  async function create(event: React.FormEvent) {
    event.preventDefault();
    if (!name.trim()) return;
    const created = await createSetlist(name.trim());
    if (created) { setLists([created, ...lists]); setName(""); }
  }

  return (
    <div className="page">
      <h1 className="serif hero-small">Your setlists</h1>

      <form onSubmit={create} style={{ display: "flex", gap: 8, marginTop: 18 }}>
        <input className="search" style={{ marginTop: 0 }} value={name}
               onChange={(event) => setName(event.target.value)}
               placeholder="Friday, Kavana Dubrovnik" />
        <button className="btn btn-primary">Create</button>
      </form>

      <ul className="song-list" style={{ marginTop: 24 }}>
        {lists.map((list) => (
          <li key={list.id} className="listrow">
            <Link to={`/setlist/${list.id}`} className="song-row">
              <span className="song-row-main">
                <span className="song-row-title">{list.name}</span>
                <span className="muted small">
                  {list.venue ?? "no venue yet"}
                  {list.share_token ? " · shared by link" : ""}
                </span>
              </span>
            </Link>
            <button
              className="btn small-btn listrow-delete"
              title="Delete this setlist"
              onClick={async () => {
                if (!confirm(`Delete "${list.name}"? The songs stay; only the list goes.`)) return;
                await deleteSetlist(list.id);
                setLists((current) => current.filter((one) => one.id !== list.id));
              }}
            >Delete</button>
          </li>
        ))}
        {!lists.length && <li className="muted">None yet. Name one above.</li>}
      </ul>
    </div>
  );
}
